<kiwi-study-header [category]="category" [title]="'studies.' + studyId | translate"
                   [displayTitle]="!!studyId"></kiwi-study-header>

<kiwi-spacer [size]="32"></kiwi-spacer>

<ng-container *ngIf="state === 'DISPLAY_SPECIMEN'">
    <div class="cell auto grid-y">
        <div *ngIf="displayStudy" class="cell shrink grid-x align-justify align-center specimenPurchase">
            <i class="fas fa-exclamation-triangle specimenPurchase-icon"></i>
            <p class="cell shrink specimenPurchase-description"><span [i18nKey]="'studies.specimen.description'"></span>
                <span [i18nKey]="'studies.specimen.price'"></span>
                <span>{{displayStudy.price | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>.</span></p>
            <button (click)="onPurchase()" class="cell shrink button _tiny _iconLeft specimenPurchase-button">
                <i class="fas fa-euro-sign"></i> <span [i18nKey]="'study.purchase'"></span></button>
        </div>

        <kiwi-spacer [size]="16"></kiwi-spacer>

        <div class="cell auto grid-y specimenContent">
            <router-outlet (activate)="onSpecimenRouterActivation($event)"></router-outlet>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="state === 'DISPLAY_STUDY'">
    <router-outlet></router-outlet>
</ng-container>
